import { create } from "zustand";
import { persist } from "zustand/middleware";

/**
 * console's OrgService does not expose a ListOrganizations RPC (confirmed
 * against console/proto/org.proto -- only Create/Get/ListMembers/Invite/
 * AcceptInvitation/UpdateMemberRole/RemoveMember exist). There is currently
 * no way for the staff admin UI to enumerate all organizations from the
 * API.
 *
 * As a practical workaround, this store keeps a small local "working set"
 * of organization IDs a staff user has looked up (by GetOrganization),
 * persisted to localStorage, so the admin organizations page has something
 * to list and re-visit without a real backend listing endpoint. This is a
 * client-side convenience only -- it is not a source of truth and does not
 * claim to show "all" organizations, only ones this browser has looked up.
 */

interface KnownOrgsState {
  ids: string[];
  add: (id: string) => void;
  remove: (id: string) => void;
}

export const useKnownOrgsStore = create<KnownOrgsState>()(
  persist(
    (set, get) => ({
      ids: [],
      add: (id) => {
        if (!id || get().ids.includes(id)) return;
        set({ ids: [id, ...get().ids] });
      },
      remove: (id) => set({ ids: get().ids.filter((existing) => existing !== id) }),
    }),
    { name: "console-web:known-org-ids" },
  ),
);
